import React, { useState, useEffect } from 'react';
import { Clock, Activity } from 'lucide-react';

export function Footer() {
  const [hasSessionToken, setHasSessionToken] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const checkToken = () => {
      setHasSessionToken(!!(window as any)?.sessionToken);
    };
    
    checkToken();
    const interval = setInterval(checkToken, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timeInterval);
  }, []);

  return (
    <div className="px-3 py-2 border-t border-navy-700/30 bg-navy-800/50">
      <div className="flex items-center justify-between gap-2 text-[10px] text-gray-500 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          {/* Status Session Token */}
          <div className={`flex items-center gap-1.5 px-2 py-0.5 rounded border ${
            hasSessionToken 
              ? 'text-green-300 bg-green-500/10 border-green-500/20' 
              : 'text-yellow-300 bg-yellow-500/10 border-yellow-500/20'
          }`}>
            <span className={`w-1.5 h-1.5 rounded-full ${
              hasSessionToken ? 'bg-green-400 animate-pulse' : 'bg-yellow-400'
            }`} />
            <span className="font-medium hidden sm:inline">
              Session: {hasSessionToken ? 'Ativo' : 'Inativo'}
            </span>
            <span className="font-medium sm:hidden">
              {hasSessionToken ? 'Ativo' : 'Inativo'}
            </span>
          </div>

          {/* Hora atual */}
          <div className="flex items-center gap-1 text-gray-400">
            <Clock className="w-3 h-3" />
            <span className="font-mono text-[10px]">
              {currentTime.toLocaleTimeString('pt-BR', { 
                hour: '2-digit', 
                minute: '2-digit',
                second: '2-digit'
              })}
            </span>
          </div>
        </div>

        {/* Versão e info */}
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 text-gray-500">
            <Activity className="w-3 h-3" />
            <span className="font-mono text-[10px]">v2.1</span>
          </div>
        </div>
      </div>
    </div>
  );
}


